import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {translate} from 'react-i18next';
import * as _ from 'lodash';
import {getPizzaExtraIngredients, getFormatPrice} from '../../../helpers';


class OrderDetailView extends Component {

  getDealOption(object, language) {
    const options = object.options;
    let result = [];
    if (options.length > 0) {
      _.forEach(options, option => {
        result.push({
          name: option.product[`name_${language}`],
          type: option.type
        });
      });
    }
    let group = _.groupBy(result, 'type');
    group['DealCompositionPizzas'] = _.countBy(group['DealCompositionPizzas'], 'name');
    group['DealCompositionProducts'] = _.countBy(group['DealCompositionProducts'], 'name');
    result = _.map(result, data => {
      data.count = group[data.type][data.name];
      return data;
    });
    return _.uniqWith(result, _.isEqual);
  }

  isType(product, type) {
    return product.type === type;
  }

  isProduct(product) {
    return !this.isType(product, 'pizza') && !this.isType(product, 'deals');
  }

  render() {
    const {data, t, language, ingredients} = this.props;
    return (
      <div className='order__detail'>
        {data.map((obj, index) => (
          <div className='order__detail-item' key={index}>
            <div className="order__detail-img">
              <img src={obj.product.cache_images.mini} alt={obj.product[`name_${language}`]} width='50'/>
            </div>
            <div className="order__detail-text">
              <div className="order__detail-name">{obj.product[`name_${language}`]}</div>
              {this.isType(obj.product, 'pizza') &&
              <div className="order__detail-size">
                {!obj.product.is_special_pizza &&
                  <React.Fragment>
                    {t(obj.size)} - &nbsp;
                  </React.Fragment>
                }
                {obj.crust[`name_${language}`]} - {obj.sauce[`name_${language}`]}
              </div>
              }
              {this.isType(obj.product, 'pizza') &&
              getPizzaExtraIngredients(obj.product, ingredients, language).map((ingredient, dataIndex) => (
                <div key={dataIndex} className="order__detail-text">
                  {ingredient.sign} {ingredient.name} x {ingredient.amount}
                </div>
              ))
              }
              {this.isType(obj.product, 'deals') &&
              <div className="order__detail-size">
                {this.getDealOption(obj, language).map((option, dataIndex) => (
                  <div key={dataIndex}>{t('cart_deal_detail', option)}</div>
                ))}</div>
                  }
                  {this.isProduct(obj.product) &&
                  <div className="order__detail-size">
                    {obj.product.optionName ? obj.product[`optionName_${language}`] : ''}{obj.product.sauce ? ' - ' + obj.product.sauce : ''}
              </div>
              }
              </div>
            <div className="order__detail-price">
                <div><strong>{t('quantity')}: </strong>{obj.quantity}</div>
                <div><strong>{t('cost')}: </strong>{getFormatPrice(obj.cost)} €</div>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

OrderDetailView.propTypes = {
  data: PropTypes.array,
  language: PropTypes.string,
  ingredients: PropTypes.array,
};

export default translate('translations')(OrderDetailView);



// WEBPACK FOOTER //
// ./src/components/Customer/Order/OrderDetailView.js